import { ref } from 'vue'
import { useRouter } from '#app'

export function useFavouriteVehicle(initialIsFavourite = false, id, name, brand) {
  const vehicle = reactive({ id, name, brand })
  const isFavourite = ref(initialIsFavourite)
  const user = useAuthUser()
  const localePath = useLocalePath()
  const router = useRouter()
  const gtm = useGtm()
  const $http = useHttp()


  const toggleFavourite = async () => {
    if (!user.value) {
      return router.push(localePath('/users/login'))
    }
    try {
      if (isFavourite.value) {
        await $http(`api/vehicles/favourites/`, {
          method: 'DELETE',
          body: JSON.stringify({ vehicle_ids: [vehicle.id] })
        })
        isFavourite.value = false
      } else {
        await $http(`api/vehicles/favourites/`, {
          method: 'PATCH',
          body: JSON.stringify({ vehicle_ids: [vehicle.id] })
        })
        isFavourite.value = true
      }
      trackBasket()
    } catch (error) {
      console.error('Failed to toggle favourite:', error)
    }
  }

  const trackBasket = () => {
    if (!import.meta.client) return
    const item = {
      id: vehicle.id,
      name: vehicle.name,
      list_name: "Favourites List",
      brand: brand,
      category: "Car Subscription",
      // list_position: this.$store.state.comparison_list.length + 1,
      list_position: 1,
      quantity: 1,
    }
    gtm.trackEvent({
      event: isFavourite.value ? 'add_to_car' : 'remove_from_cart',
      user_id: user.value?.id || null,
      items: [item]
    })
  }

  return {
    isFavourite,
    toggleFavourite,
  }
}
